<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21 19H3a1 1 0 01-1-1V6a1 1 0 011-1h18a1 1 0 011 1v12a1 1 0 01-1 1zm0-1zM3 6v12h18V6z"/><path d="M15.5 10h-.28A2 2 0 0012 7.69 2 2 0 008.78 10H8.5a.5.5 0 00-.5.5v6a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-6a.5.5 0 00-.5-.5zm-4 3H9v-2h2.5zm1-2H15v2h-2.5zm1-3a1 1 0 010 2h-1V9a1 1 0 011-1zm-4 1a1 1 0 012 0v1h-1a1 1 0 01-1-1zM9 14h2.5v2H9zm3.5 2v-2H15v2z"/></svg>